import { FC } from 'react';
import JobsFilter from 'containers/jobs/components/JobsFilter';
import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { AmountFilterOperation } from 'constants/common';
import SearchWithDropdown from 'components/search-with-dropdown/SearchWithDropdown';
import { SearchItemType } from 'types/baseTypes';
import { payRunJobReviewSearchTypes } from '../../constants';

interface JobReviewFiltersProps {
  selectedCustomers: string[];
  setSelectedCustomers: (customers: string[]) => void;
  selectedMerchants: string[];
  setSelectedMerchants: (merchants: string[]) => void;
  leadSources: string[];
  setLeadSources: (leadSources: string[]) => void;
  amountFilter: {
    filterOperation: AmountFilterOperation;
    minAmount: number | null;
    maxAmount: number | null;
  };
  setAmountFilter: (filter: any) => void;
  scheduleStartDate: string | null;
  setScheduleStartDate: (date: string | null) => void;
  scheduleEndDate: string | null;
  setScheduleEndDate: (date: string | null) => void;
  externalCompanies: string[];
  setExternalCompanies: (companies: string[]) => void;
  selectedTags: string[];
  setSelectedTags: (tags: string[]) => void;
  selectedServiceAreas: string[];
  setSelectedServiceAreas: (areas: string[]) => void;
  searchText: string;
  onSearchTermChange: (text: string) => void;
  onClearSearch: () => void;
  searchType: SearchItemType;
  setSearchType: (searchType: SearchItemType) => void;
}

const JobReviewFilters: FC<JobReviewFiltersProps> = ({
  selectedCustomers,
  setSelectedCustomers,
  selectedMerchants,
  setSelectedMerchants,
  leadSources,
  setLeadSources,
  amountFilter,
  setAmountFilter,
  scheduleStartDate,
  setScheduleStartDate,
  scheduleEndDate,
  setScheduleEndDate,
  externalCompanies,
  setExternalCompanies,
  selectedTags,
  setSelectedTags,
  selectedServiceAreas,
  setSelectedServiceAreas,
  searchText,
  onSearchTermChange,
  onClearSearch,
  searchType,
  setSearchType
}) => {
  const currentTeam = useAppSelector(selectCurrentTeam);

  const handleDateRangeChange = (startDate: string | null, endDate: string | null) => {
    setScheduleStartDate(startDate);
    setScheduleEndDate(endDate);
  };

  return (
    <div className="flex gap-4">
      {/* Search Component */}
      <div className="flex items-center gap-3">
        <SearchWithDropdown
          showSuggestionList={false}
          selectedOption={searchType}
          setSelectedOption={setSearchType}
          menuItems={payRunJobReviewSearchTypes}
          searchId="job-review-search"
          onClearSearchInput={onClearSearch}
          onSearchInputChange={onSearchTermChange}
          searchInputvalue={searchText}
          wrapperStyle="w-[323px] cursor-pointer"
          dropDownStyle="min-w-[113px] font-normal text-sbase"
          autoFocus={false}
        />
      </div>

      {/* Existing Filters */}
      <JobsFilter
        currentTeamId={currentTeam.id}
        selectedCustomers={selectedCustomers}
        setSelectedCustomers={setSelectedCustomers}
        selectedMerchants={selectedMerchants}
        setSelectedMerchants={setSelectedMerchants}
        leadSources={leadSources}
        setLeadSources={setLeadSources}
        amountFilter={amountFilter}
        setAmountFilter={setAmountFilter}
        scheduleStartDate={scheduleStartDate}
        setScheduleStartDate={setScheduleStartDate}
        scheduleEndDate={scheduleEndDate}
        setScheduleEndDate={setScheduleEndDate}
        externalCompanies={externalCompanies}
        setExternalCompanies={setExternalCompanies}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        showStatusFilter={false}
        showTeamFilter={false}
        selectedServiceAreas={selectedServiceAreas}
        setSelectedServiceAreas={setSelectedServiceAreas}
        onDateRangeChange={handleDateRangeChange}
      />
    </div>
  );
};

export default JobReviewFilters;
